import { EventModelDetails } from '../types';

export const formatModelDetails = (model: EventModelDetails) => {
  return model.sizes.map((item) => ({
    sizeId: item.size.id,
    modelId: model.model.id,
    position: model.sides,
    quantity: item.quantity.toString(),
  }));
};
